<template>
	<div>
		<h1 class="title">{{ title }}</h1>
		<p class="subtitle">{{ description }}</p>

		<hr />
		<div class="level">
			<div class="level-left">
				<health-services-filter class="level-item" />
				<hospitals-filter class="level-item" />
			</div>
			<div class="level-right">
				<date-filter class="level-item" />
			</div>
		</div>
		<hr />

		<chart-view
			v-for="(type, index) in types"
			:key="index"
			:type="type"
			:name="name"
		>
		</chart-view>
	</div>
</template>

<script>
import ChartView from "./ChartView";
import { mapGetters, mapActions } from "vuex";

export default {
	name: "AppChartViewer",
	components: { ChartView },
	props: {
		chart: {
			type: Object,
			default: null
		}
	},
	computed: {
		title() {
			return this.chart.title;
		},
		description() {
			return this.chart.description;
		},
		name() {
			return this.chart.name;
		},
		types() {
			return this.chart.types;
		}
	}
};
</script>
